import { FC } from 'react';
import { Box, SvgIcon } from '@mui/material';
import { Button, Divider } from '@qlub-dev/qlub-kit';
import AppleSignIn from 'react-apple-signin-auth';
import { Apple } from '@mui/icons-material';
import { useTranslation } from '../../../hook/translations';
import GoogleIcon from '../../Icons/googleIcon';
import { IAppleData } from '../DataManager/dataManager';

import styles from '../index.module.scss';

interface IProps {
    fullPage?: boolean;
    handleAppleLogin?: (loginData: IAppleData) => void;
    handleGoogleLoginInit: () => void;
    withSSOLogin?: boolean;
    onModalClose?: () => void;
}

// eslint-disable-next-line react/function-component-definition
const AdditionalPhonePhaseElements: FC<IProps> = ({ handleAppleLogin, handleGoogleLoginInit, withSSOLogin }) => {
    const { t } = useTranslation('common');

    const renderAppleLogin = () => {
        if (!process.env.NEXT_PUBLIC_APPLE_CLIENT_ID || !process.env.NEXT_PUBLIC_APPLE_REDIRECT_URL) {
            return null;
        }

        return (
            <AppleSignIn
                authOptions={{
                    clientId: process.env.NEXT_PUBLIC_APPLE_CLIENT_ID,
                    redirectURI: process.env.NEXT_PUBLIC_APPLE_REDIRECT_URL,
                    usePopup: true,
                    scope: 'email name',
                }}
                onSuccess={handleAppleLogin}
                onError={(err: any) => console.log(err)}
                render={(props: any) => (
                    <Button
                        variant="outlined"
                        startIcon={
                            <SvgIcon>
                                <Apple />
                            </SvgIcon>
                        }
                        icon="left"
                        sx={{
                            color: 'black',
                            span: {
                                width: 'fit-content !important',
                            },
                        }}
                        fullWidth
                        {...props}
                    >
                        {t('Continue with Apple')}
                    </Button>
                )}
            />
        );
    };

    const renderGoogleLogin = () => {
        return (
            <Button
                variant="outlined"
                startIcon={
                    <SvgIcon>
                        <GoogleIcon />
                    </SvgIcon>
                }
                icon="left"
                sx={{
                    color: 'black',
                    span: {
                        width: 'fit-content !important',
                    },
                    mt: 3,
                }}
                fullWidth
                onClick={() => {
                    handleGoogleLoginInit();
                }}
            >
                {t('Continue with Google')}
            </Button>
        );
    };

    return (
        <Box>
            {withSSOLogin && (
                <>
                    <div className={styles.divider}>
                        <Divider type="fullWidth" text={t('Or')} />
                    </div>

                    <div className={styles.buttonContainer}>
                        {renderAppleLogin()}
                        {renderGoogleLogin()}
                    </div>
                </>
            )}
        </Box>
    );
};

export default AdditionalPhonePhaseElements;
